<template>
  <div class="xscontainer jsjiesh">
    <div class="gsgdfgsdf">
<!--      <div class="biaoti1_center">在线直播学习</div>-->

      <SearchBox style="width: 100%"  @search="chaxunzhibo"></SearchBox>
      <div class="kkkllle">
        <div class="btkk">
          <p class="biaoti2">近期直播预告</p>
          <img class="tbdx" src="@/assets/xxkc/7@4x.png"/>
        </div>
        <div class="klwe123" v-for="(item, index) in jinqizhibos">
          <div class="hengdiv kkdls">
            <img class="jjddser" src="@/assets/xxkc/zhibotu.jpg"/>
            <div class="kkkllle_center234231 wzslh_wrap"  @click="gotoZbxq(item)">
              <p class="biaoti3">{{item.zhibobt}}</p>
              <div class="hengdiv">
                <p class="zhengwen_grey wzslh">主题介绍:{{item.zhibodescrib}}</p>
                <p class="zhengwen_grey">直播时间:{{item.zhibotime}}</p>
                <p class="zhengwen_grey">直播讲师:{{item.zhujiangren}}</p>
              </div>
            </div>
          </div>
          <div class="rgds">
<!--            <img class="jjdlkfe" src="@/assets/xxkc/xdouyin.png"/>-->
<!--            <img class="jjdlkfe" src="@/assets/xxkc/xweixin.png"/>-->
            <img class="jjdlkfe" @click="copyLink(item.lianjie)" src="@/assets/xxkc/fenxiang2.png"/>
          </div>
        </div>
        <el-pagination
            align="center"
            @size-change="handleSizeChange1"
            @current-change="handleCurrentChange1"
            :current-page="currentPage1"
            :page-sizes="[3, 5, 8, 10]"
            :page-size="pagesize1"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total1">
        </el-pagination>
      </div>
      <div class="kkkllle">
        <div class="btkk">
          <p class="biaoti2">往期直播回顾</p>
          <img class="tbdx" src="@/assets/xxkc/7@4x.png"/>
        </div>
        <div class="klwe123" v-for="(item, index) in wangqizhibos">
          <div class="hengdiv kkdls"   @click="gotoZbxq(item)">
            <img class="jjddser" src="@/assets/xxkc/zhibotu.jpg"/>
            <div class="kkkllle_center234231 wzslh_wrap">
              <p class="biaoti3">{{item.zhibobt}}</p>
              <div class="hengdiv">
                <p class="zhengwen_grey">主题介绍:{{item.zhibodescrib}}</p>
                <p class="zhengwen_grey">直播时间:{{item.zhibotime}}</p>
                <p class="zhengwen_grey">直播讲师:{{item.zhujiangren}}</p>
              </div>
            </div>
          </div>
          <div class="rgds">
<!--            <img class="jjdlkfe" src="@/assets/xxkc/xdouyin.png"/>-->
<!--            <img class="jjdlkfe" src="@/assets/xxkc/xweixin.png"/>-->
            <img class="jjdlkfe" @click="copyLink(item.lianjie)" src="@/assets/xxkc/fenxiang2.png"/>
          </div>
        </div>
        <el-pagination
            align="center"
            @size-change="handleSizeChange2"
            @current-change="handleCurrentChange2"
            :current-page="currentPage2"
            :page-sizes="[3, 5, 8, 10]"
            :page-size="pagesize2"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total2">
        </el-pagination>
      </div>
    </div>
    <div class="dsfsdfg" v-model="fwcishu">【访问次数:{{fwcishu}}】</div>
  </div>
</template>

<script>
import SearchBox from "@/components/lianmeng/common/SearchBox";
export default {
  components:{
    SearchBox
  },
  name: 'HomePage',
  data() {
    return {
      jinqizhibos:[],
      wangqizhibos:[],
      pagesize1:3,
      currentPage1: 1,
      total1:0,
      pagesize2:3,
      currentPage2: 1,
      total2:0,
      link:'',
      currentText:'',
      fwcishu:0
    }
  },
  mounted() {
    this.queryJinqi();
    this.queryWangqi();

    this.link = window.location.href;
  },
  created() {
    this.tongji('在线直播');
  },
  methods:{
    tongji(caidan) {
      var that = this;
      this.$ajax
          .post(this.GLOBAL.sys_addr + '/tongji/tTongji/tj', {caidan: caidan})
          .then(function (response) {
            if (response.status == 200) {
              that.fwcishu = response.data;
            }
          });
    },
    chaxunzhibo(stext){
      this.currentText = stext;
      this.queryJinqiLike(stext)
      this.queryWangqiLike(stext)
    },
    queryJinqiLike(stext){
      var that = this;
      this.$ajax
          .get(this.GLOBAL.sys_addr + '/zhibo/tZhibo/list?_t='+new Date().getTime()+'&column=createTime&zhibobt=*'+stext+'*&order=desc&pageNo='+this.currentPage1+'&pageSize='+this.pagesize1)
          .then(function (response) {
            if (response.data.code == 200) {
              debugger
              that.jinqizhibos  = response.data.result.records;
              that.currentPage1 = response.data.result.current;
              that.total1 = response.data.result.total;
            } else {
              that.$notify.warning({ position: 'bottom-right', title: '提示', message: response.data.msg });
            }
          });
    },
    queryWangqiLike(stext){
      var that = this;
      this.$ajax
          .get(this.GLOBAL.sys_addr + '/zhibo/tZhibo/wqlist?_t='+new Date().getTime()+'&column=createTime&zhibobt=*'+stext+'*&order=desc&pageNo='+this.currentPage2+'&pageSize='+this.pagesize2)
          .then(function (response) {
            if (response.data.code == 200) {
              debugger
              that.wangqizhibos  = response.data.result.records;
              that.currentPage2 = response.data.result.current;
              that.total2 = response.data.result.total;
            } else {
              that.$notify.warning({ position: 'bottom-right', title: '提示', message: response.data.msg });
            }
          });
    },
    gotoZbxq(item){
      this.$router.push({path:'/zhiboxiangqing',query:{item:item}});
    },
    copyLink(lianjie) {
      const el = document.createElement('textarea')
      // el.value = this.link
      el.value = lianjie
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
    },
    handleSizeChange1(val) {
      this.pagesize1 = val;
      if(this.currentText){
        this.queryJinqiLike(this.currentText);
      }else{
        this.queryJinqi();
      }

    },
    handleCurrentChange1(val) {
      this.currentPage1 = val;
      if(this.currentText){
        this.queryJinqiLike(this.currentText);
      }else{
        this.queryJinqi();
      }
    },
    queryJinqi(){
      var that = this;
      this.$ajax
          .get(this.GLOBAL.sys_addr + '/zhibo/tZhibo/list?_t='+new Date().getTime()+'&column=createTime&order=desc&pageNo='+this.currentPage1+'&pageSize='+this.pagesize1)
          .then(function (response) {
            if (response.data.code == 200) {
              debugger
              that.jinqizhibos  = response.data.result.records;
              that.currentPage1 = response.data.result.current;
              that.total1 = response.data.result.total;
            } else {
              that.$notify.warning({ position: 'bottom-right', title: '提示', message: response.data.msg });
            }
          });
    },

    handleSizeChange2(val) {
      this.pagesize2 = val;
      if(this.currentText){
        this.queryWangqiLike(this.currentText);
      }else{
        this.queryWangqi();
      }
    },
    handleCurrentChange2(val) {
      this.currentPage2 = val;
      if(this.currentText){
        this.queryWangqiLike(this.currentText);
      }else{
        this.queryWangqi();
      }
    },
    queryWangqi(){
      var that = this;
      this.$ajax
          .get(this.GLOBAL.sys_addr + '/zhibo/tZhibo/wqlist?_t='+new Date().getTime()+'&column=createTime&order=desc&pageNo='+this.currentPage2+'&pageSize='+this.pagesize2)
          .then(function (response) {
            if (response.data.code == 200) {
              debugger
              that.wangqizhibos  = response.data.result.records;
              that.currentPage2 = response.data.result.current;
              that.total2 = response.data.result.total;
            } else {
              that.$notify.warning({ position: 'bottom-right', title: '提示', message: response.data.msg });
            }
          });
    }

  }
}
</script>

<style  scoped>
.gsgdfgsdf{
  width: 60%;
}
.btkk{
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 3px;
}
.klwe123{
  border: 1px solid #92aee8;
  display: flex;
  justify-content: space-between;
  padding: 1rem;
}

.rgds{
  width: 5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}
.jjdlkfe{
  width:4rem;
  height: 4rem;
}
.llll{
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.kkdls{
  display: flex;
  gap: 2rem;
}
.mydivcss{
  width: 100%;
  justify-content: space-between;
  margin-top: 2rem;
}
.kkdsv{
  width: 22%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.nkkvsdfe{
  width: 8rem;
  height: 5rem;
}
.kkkllle_center234231{
  width: 60%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: center;
  align-content: center;
}
.kkkllle_center234231:hover{
  cursor: pointer;
  color: #0f7cf1;
}
.jjddser{
  width: 30%;
  height: 8rem;
}
.kkkllle{
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 2rem;
}
.jjdlkfe:hover{
  transform: scale(1.2);
  cursor: pointer;
}
</style>
